import { JarvisWebHttpClient } from '@jarvis/web-http'
import { getPswApiStack } from '../utils'
import { handleUserAgentData } from '../utils/handleUserAgentData'

class PSWApiClient {
  constructor(stack, clientId) {
    ;(this.jarvisWebHttpInstance = new JarvisWebHttpClient()),
      (this.stack = stack),
      (this.clientId = clientId)
  }

  /**
   * @param {string} endpoint
   * @returns {string}
   */
  _buildApiUrl(endpoint) {
    return `${getPswApiStack(this.stack)}${endpoint}`
  }

  /**
   * @param {string} url
   * @returns {Promise<any>}
   */
  async _getClient(url) {
    return await this.jarvisWebHttpInstance.get({
      url,
      headers: {
        'x-hp-client-id': this.clientId
      }
    })
  }

  /**
   * @param {string} query
   * @returns {Promise<any>}
   */
  async searchDevices(query) {
    const apiUrl = this._buildApiUrl(`/api/v1/typeahead?query=${query}`)
    const response = await this._getClient(apiUrl)
    return response
  }

  /**
   * @param {{ sku: string }} sku
   * @returns {Promise<any>}
   */
  async fetchBasicDrivers({ sku }) {
    let apiUrl
    if (await handleUserAgentData().isWindows11()) {
      apiUrl = this._buildApiUrl(`/api/v1/software/${sku}?os=windows11`)
    } else {
      apiUrl = this._buildApiUrl(`/api/v1/software/${sku}`)
    }
    return this._getClient(apiUrl)
  }

  /**
   * @returns {Promise<any>}
   */
  async getDeviceSearchList() {
    const apiUrl = this._buildApiUrl('/api/v1/searchList')
    const response = await this._getClient(apiUrl)
    return response
  }

  /**
   * @param {{sku: string}} sku
   * @returns {Promise<any>}
   */
  async fetchImageBySkuInHermes({ sku }) {
    const width = 700
    const height = 400
    const apiUrl = this._buildApiUrl(
      `/api/v1/images/${sku}?width=${width}&height=${height}`
    )
    const response = await this._getClient(apiUrl)
    const { imageUrl } = await response.data

    console.info('[IMAGE FLOW] Returning image URL from Hermes API')
    return imageUrl
  }
}

export default PSWApiClient
